export const initialEventLogsState = {
    eventLogDataByHomeIdByLogResourcePathBySearchParams: {},
};
